import React from "react";
import { AlertCircle, BookOpen } from "lucide-react";

/**
 * ErrorState - Display when data fails to load
 */
export const ErrorState = ({
  title = "Something went wrong",
  description = "We encountered an error while loading this content. Please try again.",
  onRetry,
  icon: Icon = AlertCircle,
}) => (
  <div className="flex flex-col items-center justify-center py-20 px-4">
    <div className="max-w-md text-center">
      <div className="mb-6 flex justify-center">
        <div className="rounded-full bg-red-50 p-4">
          <Icon className="h-12 w-12 text-red-600" />
        </div>
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-2">{title}</h3>
      <p className="text-slate-500 mb-6">{description}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold hover:shadow-lg transition-all"
        >
          Try Again
        </button>
      )}
    </div>
  </div>
);

/**
 * EmptyState - Display when there's no data to show
 */
export const EmptyState = ({
  title = "No content found",
  description = "There's nothing to display right now. Check back later!",
  icon = "BookOpen",
  actionText,
  onAction,
}) => {
  // Map icon names to icon components
  const iconMap = {
    BookOpen: BookOpen,
    AlertCircle: AlertCircle,
  };

  const IconComponent = iconMap[icon] || BookOpen;

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-slate-100 p-4">
            <IconComponent className="h-12 w-12 text-slate-400" />
          </div>
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-2">{title}</h3>
        <p className="text-slate-500 mb-6">{description}</p>
        {actionText && onAction && (
          <button
            onClick={onAction}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-gradient-to-r from-violet-600 to-purple-600 text-white font-semibold hover:shadow-lg transition-all"
          >
            {actionText}
          </button>
        )}
      </div>
    </div>
  );
};
